(function () {
  'use strict';

  angular
    .module('edistradadhluiApp')
    .run(versionCheckOnStateChange);

  versionCheckOnStateChange.$inject = ['$rootScope', 'VersionCheck'];

  function versionCheckOnStateChange($rootScope, VersionCheck) {
    $rootScope.$on('$stateChangeStart', function () {
      VersionCheck.checkAndReloadIfNeeded();
    });
  }
})();
